import * as React from 'react';
import styled from 'styled-components';

interface ICatizCursorInfoAreaProps {
  style?: any;
}

const TableContainer = styled.table``;
const TableHead = styled.thead``;
const TableBody = styled.tbody``;
const TableHeadCell = styled.tr`
  padding: 2px;
  text-align: left;
`;
const TableRow = styled.tr``;
const TableRowCell = styled.td`
  padding: 2px;
`;

const CatizCursorInfoArea: React.FunctionComponent<
  ICatizCursorInfoAreaProps
> = (props) => {
  return (
    <TableContainer {...props}>
      <TableBody>
        <TableRow>
          <TableRowCell>LAT:</TableRowCell>
          <TableRowCell>0:0:0 N</TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>LONG:</TableRowCell>
          <TableRowCell>0:0:0 E</TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>HEADING:</TableRowCell>
          <TableRowCell>000 T</TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>COURSE: </TableRowCell>
          <TableRowCell>000 T</TableRowCell>
        </TableRow>
        <TableRow>
          <TableRowCell>SPEED: </TableRowCell>
          <TableRowCell>0.0 KTS</TableRowCell>
        </TableRow>
      </TableBody>
    </TableContainer>
  );
};

export default CatizCursorInfoArea;
